import { Icon } from "./Icon.tsx";

/** "Transects" tab icon — an irregular natural-channel cross-section (a
 * notch, not a straight line) with a waterline, distinct from
 * ProfileIcon.tsx's own longitudinal elevation line (that one runs ALONG a
 * route; this one cuts ACROSS a channel). */
export function TransectIcon() {
  return (
    <Icon>
      <path d="M2 7 5 9 8 17h8l3-8 3-2" />
      <path d="M6 17h12" />
    </Icon>
  );
}
